import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {
  ButtonRecordValue,
  HistoryRecordValue,
  RecordData, RecordDataValue,
  RecordTableColumnParams,
  RecordUpdateParams
} from '../../../../types/records-table.types';
import {objectValidationModalKeys} from "../modal-record-table-item/configs/modal-record-table-item-config";
import {DEFAULT_ZOOM} from "../../../../constants/constants";
import {ResourceParams} from "../../../../models/resource/resources";
import {TelegramChatHistoryStateService} from "../../../../services/telegram-chat-history-state.service";
import {defaultResourceParams} from "../../../../models/resource/default-resource-params";
import {defaultRecordData} from "../../../../models/default-record-data";

@Component({
  selector: 'app-record-table-items-list',
  standalone: false,
  templateUrl: './record-table-items-list.component.html',
  styleUrl: './record-table-items-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordTableItemsListComponent {
  @Input({ required: true }) columnParam!: RecordTableColumnParams;
  @Input({ required: true }) record: RecordData = defaultRecordData;
  @Input({ required: true }) resourceParams: ResourceParams = defaultResourceParams;
  @Input() currentTableZoom: number = DEFAULT_ZOOM;
  @Input() isEditModeActive: boolean = false;
  @Output() recordUpdated: EventEmitter<RecordUpdateParams> = new EventEmitter<RecordUpdateParams>;
  @Output() reloadTableData: EventEmitter<void> = new EventEmitter<void>;

  private telegramChatHistoryStateService: TelegramChatHistoryStateService = inject(TelegramChatHistoryStateService);

  protected handleRecordUpdate(recordId: string | number, key: string, value: unknown): void {
    this.recordUpdated.emit({
      recordId,
      value,
      fieldName: key
    });
  }

  protected isDataExists(columnParam: RecordTableColumnParams, record: RecordData): boolean {
    const objectValidationKey = objectValidationModalKeys[columnParam.key];

    if (objectValidationKey) {
      return !!(record[objectValidationKey] as ButtonRecordValue)?.valid || !!(record[objectValidationKey] as ButtonRecordValue)?.isValid;
    }

    if (columnParam.key === 'history') {
      return !!(record['history'] as HistoryRecordValue)?.history?.length;
    }

    if (columnParam.key === 'chatHistory') {
      return !!this.telegramChatHistoryStateService.getTelegramChatHistoryById(Number(record.id))?.chatStarted;
    }

    return !!record[columnParam.key];
  }

  public handleReloadTableData(): void {
    this.reloadTableData.emit();
  }

  public getStringValue(value?: RecordDataValue): string {
    if (value === null || value === undefined) { value = ''; }

    return String(value);
  }
}
